import axios from 'axios';

const API_BASE_URL = import.meta.env.VITE_BACKEND_PROXY_URL || 'http://localhost:5000';

/**
 * Analytics API Service - Frontend service for analytics data
 */
class AnalyticsApiService {
  
  /**
   * Get complete analytics dashboard data
   */
  async getAnalyticsDashboard(restaurantId, period = 'last_7_days', startDate = null, endDate = null) {
    try {
      const params = { period };
      if (startDate) params.start_date = startDate;
      if (endDate) params.end_date = endDate;

      const response = await axios.get(
        `${API_BASE_URL}/api/analytics/dashboard/${restaurantId}`,
        { params }
      );

      return response.data;
    } catch (error) {
      console.error('Error fetching analytics dashboard:', error);
      throw error;
    }
  }

  /**
   * Helper to format period for API
   */
  formatPeriod(timeRange) {
    const periodMap = {
      '1d': 'today',
      'today': 'today',
      'yesterday': 'yesterday',
      '7d': 'last_7_days',
      '30d': 'last_30_days',
      '90d': 'last_30_days', // API doesn't have 90 days, use 30
      'this_month': 'this_month',
      'last_month': 'last_month'
    };

    return periodMap[timeRange] || 'last_7_days';
  }
}

export default new AnalyticsApiService();
